export default {
  loadedProduct: {},
  quickOpenBatch: {
    id: null,
    product_id: null,
  },
};
